<template>
    <v-range-slider
            :tick-labels="labels"
            v-model="startEndModel"
            min="0"
            max="48"
            hide-details
    >
        <template v-slot:thumb-label="props">
            {{ Math.floor(props.value / 2) }}:{{(props.value%2 * 30 + '').padStart(2, '0')}}
        </template>
    </v-range-slider>
</template>

<script>
export default {
    props: {
        labels: Array,
        value: [Array, Object],
        title: String
    },
    computed: {
        startEndModel: {
            get() {
                return [this.value.start || 0, this.value.end || 0]
            },
            set(val) {
                this.$emit('input', {
                    start: val[0],
                    end: val[1],
                })

            }
        }
    },
}
</script>

<style scoped>

</style>